"use client"
import { usePathname } from 'next/navigation'
import { useEffect } from 'react'

declare global {
    interface Window {
        gtag: (...args: unknown[]) => void
    }
}

export function GoogleAnalyticsTracker({ measurementId }: { measurementId: string }) {
    const pathname = usePathname()

    useEffect(() => {
        if (typeof window.gtag !== 'function') return
        window.gtag('config', measurementId, { page_path: pathname })
    }, [pathname, measurementId])

    return null
}
